export default __webpack_public_path__ + "static/media/829.25a00dc1.png";